import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import esLocale from "date-fns/locale/es";
import DateFnsUtils from "@date-io/date-fns";
import {
    FormControlLabel,
    Grid,
    Paper,
    Radio,
    RadioGroup,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from "@material-ui/pickers";
import { useForm } from "../../../hooks/useForm";
import { SURGE_CARGA_IMAGENES_BUSQUEDA } from "../../../utils/constants";
import { GestionImagenesItem } from "./gestionImagenes/GestionImagenesItem";
import { useSurge } from "../../../hooks/useCases/useSurge";
import { setEstadoBandejaImagenes, traerSolicitudesAltoCosto, traerSolicitudesConIdentificacionSurge, traerSolicitudesHiv, traerSolicitudesMaterialesSurge, traerSolicitudPagoConOPSurge, traerSolicitudPagoSurge } from "../../../actions/surge/bandejaImagenes";
import { ColumnaAltoCosto } from "./gestionImagenes/table/altoCosto/ColumnaAltoCosto";
import { ColumnaMateriales } from "./gestionImagenes/table/materiales/ColumnaMateriales";
import { ColumnaSolicitudes } from "./gestionImagenes/table/solicitudes/ColumnaSolicitudes";
import { ColumnaSolPago } from "./gestionImagenes/table/solPago/ColumnaSolPago";
import { ColumnaSolPagoOP } from "./gestionImagenes/table/solPagoConOP/ColumnaSolPagoOP";
import Buscador from "../../../actions/ui/Buscador";
import { AutorizacionesBuscador } from "../../autorizaciones/Ingreso/AutorizacionesBuscador";
import { ColumnaHiv } from "./gestionImagenes/table/hiv/ColumnaHiv";



const useStyles = makeStyles({
    root: {
        padding: 10,
        flexGrow: 1,
        marginTop: 10,
        // width: "100%",
    },
    input: {
        // padding: 10,
        paddingLeft: 10,
        paddingRight: 10,
    },
    buscador: {
        padding: 8,
    },
});

const today = new Date();
const threeMonthsAgo = new Date(today);
threeMonthsAgo.setMonth(today.getMonth() - 1);

const stateInitial = {
    fechaInicio: threeMonthsAgo,
    fechaFin: today,
};

export const GestionImagenesAutorizaciones = (props) => {

    const classes = useStyles();
    const [formValues, , , setearValor] = useForm(stateInitial);
    const dispatch = useDispatch();
    const surge = useSurge();
    const { fechaInicio, fechaFin } = formValues;

    const {
        afiliadoSeleccionado,
    } = useSelector((state) => state.autorizaciones);

    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [dense, setDense] = useState(true);
    const [page, setPage] = useState(0);
    const [contadorBandeja, setContadorBandeja] = useState(0);
    const [radioGroupDisabled, setRadioGroupDisabled] = useState(false);
    const [diagnostico, setDiagnostico] = useState(null);

    const arrayEstadosSolicitudes = Object.entries(SURGE_CARGA_IMAGENES_BUSQUEDA);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const componentRef = React.useRef();

    useEffect(() => {
        debugger
        if (Number(surge.data.estadosImagenes) === SURGE_CARGA_IMAGENES_BUSQUEDA.ALTO_COSTO) {
            dispatch(traerSolicitudesAltoCosto(fechaInicio, fechaFin, afiliadoSeleccionado?.id_afiliado, diagnostico?.idProblema, setContadorBandeja, setRadioGroupDisabled))
        }
        if (Number(surge.data.estadosImagenes) === SURGE_CARGA_IMAGENES_BUSQUEDA.MATERIALES) {
            dispatch(traerSolicitudesMaterialesSurge(fechaInicio, fechaFin, afiliadoSeleccionado?.id_afiliado, diagnostico?.idProblema, setContadorBandeja, setRadioGroupDisabled))
        }
        if (Number(surge.data.estadosImagenes) === SURGE_CARGA_IMAGENES_BUSQUEDA.SOLICITUDES) {
            dispatch(traerSolicitudesConIdentificacionSurge(fechaInicio, fechaFin, afiliadoSeleccionado?.id_afiliado, diagnostico?.idProblema, setContadorBandeja, setRadioGroupDisabled))
        }
        if (Number(surge.data.estadosImagenes) === SURGE_CARGA_IMAGENES_BUSQUEDA.SOL_DE_PAGO_LIQUIDACIONES) {
            dispatch(traerSolicitudPagoSurge(fechaInicio, fechaFin, afiliadoSeleccionado?.id_afiliado, diagnostico?.idProblema, setContadorBandeja, setRadioGroupDisabled))
        }
        if (Number(surge.data.estadosImagenes) === SURGE_CARGA_IMAGENES_BUSQUEDA.SOL_DE_PAGO_CON_OP_RECIBOS_Y_RETENCIONES) {
            dispatch(traerSolicitudPagoConOPSurge(fechaInicio, fechaFin, afiliadoSeleccionado?.id_afiliado, diagnostico?.idProblema, setContadorBandeja, setRadioGroupDisabled))
        }
        if (Number(surge.data.estadosImagenes) === SURGE_CARGA_IMAGENES_BUSQUEDA.HIV) {
            dispatch(traerSolicitudesHiv(fechaInicio, fechaFin, afiliadoSeleccionado?.id_afiliado, diagnostico?.idProblema, setContadorBandeja, setRadioGroupDisabled))
        }
    }, [dispatch, surge.data.estadosImagenes, fechaInicio, fechaFin, afiliadoSeleccionado, diagnostico]);

    console.log(afiliadoSeleccionado)


    return (
        <Grid container className={classes.root} justify="center" spacing={1}>
            <Grid item xs={12}>
                <Grid container direction="row" alignItems="center" spacing={1}>
                    <Grid item xs={12} md={5}>
                        <AutorizacionesBuscador hideTitle={true} disabled={setRadioGroupDisabled} />
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <Paper elevation={2} style={{ padding: "0.9em" }}>
                            <Buscador
                                value={diagnostico}
                                setValue={(val) => setDiagnostico(val)}
                                label="Diagnostico"
                                endpoint={(param) => `Diagnosticos/buscar?texto=${param}`}
                                noOptionText={"No se encuentran diagnosticos"}
                                getOptionLabel={(option) => `${option.problema}`}
                            />
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={1}>
                        <Paper className={classes.input}>
                            <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    margin="normal"
                                    label="Fecha Inicio"
                                    format="dd/MM/yyyy"
                                    // required={true}
                                    clearLabel="Limpiar"
                                    cancelLabel="Cancelar"
                                    value={
                                        moment(fechaInicio).isValid() ? moment(fechaInicio).format() : null
                                    }
                                    onChange={(date) => {
                                        setearValor("fechaInicio", date);
                                    }}
                                    KeyboardButtonProps={{
                                        "aria-label": "change date",
                                    }}
                                    disabled={radioGroupDisabled}
                                />
                            </MuiPickersUtilsProvider>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={1}>
                        <Paper className={classes.input}>
                            <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    margin="normal"
                                    label="Fecha Fin"
                                    format="dd/MM/yyyy"
                                    // required={true}
                                    clearLabel="Limpiar"
                                    cancelLabel="Cancelar"
                                    value={moment(fechaFin).isValid() ? moment(fechaFin).format() : null}
                                    onChange={(date) => {
                                        setearValor('fechaFin', date);
                                    }}
                                    KeyboardButtonProps={{
                                        "aria-label": "change date",
                                    }}
                                    disabled={radioGroupDisabled}
                                />
                            </MuiPickersUtilsProvider>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={12} style={{ alignItems: "right", textAlign: "right" }}>
                        <Typography component="h1"
                            variant="h5"
                            style={{
                                marginLeft: 25,
                                marginTop: 20,
                                align: "center",
                                //color: "#FAFAFA",
                                justifyContent: "center",
                            }}>
                            {`Total Listado: ${contadorBandeja}`}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Paper style={{ padding: "0.25rem", marginTop: -5 }}>
                    <RadioGroup
                        row
                        style={{ justifyContent: "space-around" }}
                        value={surge.data.estadosImagenes}
                        onChange={(e) => {
                            dispatch(setEstadoBandejaImagenes(e.target.value));
                        }}
                    >
                        {arrayEstadosSolicitudes.map((estadoSolicitud, index) => {
                            //const contador = solicitudesContadores.find(s => s.estado === estadoSolicitud[1]);
                            const label =
                                estadoSolicitud[0].charAt(0) +
                                estadoSolicitud[0].replace(/_/g, " ").toLowerCase().slice(1);
                            // +
                            // ((!!contador)
                            //   ?
                            //     `(${contador.totalItems})`
                            //   :
                            //     `(...)`
                            // );
                            return (
                                <FormControlLabel
                                    key={index}
                                    style={{ marginLeft: "0.5rem" }}
                                    label={label}
                                    value={estadoSolicitud[1]?.toString()}
                                    control={<Radio />}
                                    disabled={radioGroupDisabled}
                                />
                            );
                        })}
                    </RadioGroup>
                </Paper>
            </Grid>
            <Grid item xs={12}>
                <TableContainer component={Paper} style={{ overflowX: "auto" }}>
                    <Table size={dense ? "small" : "medium"} ref={componentRef}>
                        <TableHead>
                            {(Number(surge.data.estadosImagenes) === SURGE_CARGA_IMAGENES_BUSQUEDA.ALTO_COSTO) && !radioGroupDisabled &&
                                <ColumnaAltoCosto />
                            }
                            {(Number(surge.data.estadosImagenes) === SURGE_CARGA_IMAGENES_BUSQUEDA.MATERIALES) && !radioGroupDisabled &&
                                <ColumnaMateriales />
                            }
                            {(Number(surge.data.estadosImagenes) === SURGE_CARGA_IMAGENES_BUSQUEDA.SOLICITUDES) && !radioGroupDisabled &&
                                <ColumnaSolicitudes />
                            }
                            {(Number(surge.data.estadosImagenes) === SURGE_CARGA_IMAGENES_BUSQUEDA.SOL_DE_PAGO_LIQUIDACIONES) && !radioGroupDisabled &&
                                <ColumnaSolPago />
                            }
                            {(Number(surge.data.estadosImagenes) === SURGE_CARGA_IMAGENES_BUSQUEDA.SOL_DE_PAGO_CON_OP_RECIBOS_Y_RETENCIONES) && !radioGroupDisabled &&
                                <ColumnaSolPagoOP />
                            }
                              {(Number(surge.data.estadosImagenes) === SURGE_CARGA_IMAGENES_BUSQUEDA.HIV) && !radioGroupDisabled &&
                                <ColumnaHiv />
                            }
                        </TableHead>
                        <TableBody>
                            {!radioGroupDisabled && surge.data.solicitudes.length > 0 ? (
                                // items.map((item) => (
                                surge.data.solicitudes
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((item) => (
                                        <GestionImagenesItem
                                            item={item}
                                            //setRedirect={setRedirect}
                                            //permisosUser={permisosUser}
                                            key={item.id?.toString()}
                                            estadosImagenes={surge.data.estadosImagenes}
                                            fechaFin={fechaFin}
                                            fechaInicio={fechaInicio}
                                            {...props}
                                        />
                                    ))
                            ) : (
                                <TableRow style={{ height: 50 }}>
                                    <TableCell
                                        colSpan={13}
                                        style={{ textAlign: "-webkit-center" }}
                                    >
                                        {" "}
                                        Sin Registros
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
            {surge.data.solicitudes.length > 0 && (
                <Grid item xs={12}>
                    <TablePagination
                        style={{ backgroundColor: "white" }}
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={surge.data.solicitudes.length}
                        rowsPerPage={rowsPerPage}
                        labelRowsPerPage="Registros por página"
                        page={page}
                        onChangePage={handleChangePage}
                        onChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                    <FormControlLabel
                        control={
                            <Switch
                                checked={dense}
                                onChange={(e) => setDense(e.target.checked)}
                            />
                        }
                        label="Tamaño compacto"
                    />
                </Grid>
            )}
        </Grid>
    )
}
